<template>
  <v-row>
    <v-dialog
    v-model="show"
      scrollable
      persistent
      max-width="500px"
    >
    <v-card>
        <v-card-text class="mt-8">
        <v-select
          v-model="userToValidate.userId"
          :items="users"
          item-text="name"
          item-value="userId"
          v-bind:label="$t('user')"
          v-bind:no-data-text="$t('noData')">
        </v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
        <v-btn
            color="blue darken-1"
            text
            @click="send"
          >
            {{ $t('send') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
    export default {
        name: "UserToValidateDialog",
        props: ['userToValidate'],
        data () {
        return {
            show: false,
            resolve: null,
            users: []
            }
        },
        methods: {
            getUsers(){
                this.axios.get('User/UsersToValidate?organizationId=' + this.$store.getters.organizationId).then((response) => {
                this.users = response.data
              })
              .catch(err => console.log(err))
            },
            async showDialog() {
              this.getUsers()
                return new Promise(resolve => {
                this.resolve = resolve
                this.show = true
                })
            },
            send() {
                if(this.userToValidate.userId > 0){
                    this.show = false
                    this.resolve && this.resolve('ok')
                }
                else
                this.$root.displayNotificationMsg(this.$t('userRequired'), 'warning')
            },
            closeDialog() {
                this.userToValidate.userId = ""
                this.show = false
                this.resolve && this.resolve('cancel')
            }
        }
    }
</script>   